export const requiredRule = [v => !!v || 'Field is required']
export const emailRule = [v => /.+@.+\..+/.test(v) || 'E-mail must be valid']
